import api from '../../services/api'
import { addErrorToast, addSaveToast } from './companyActionCreators'

import {
  BACKUP365_REPORT_COMPANIES_LOADED,
  BACKUP365_REPORT_DETAILS_LOADED,
  BACKUP365_REPORT_DETAILS_NOTFOUND,
  BACKUP365_REPORT_LOADING,
  BACKUP365_REPORT_COMPANY_SELECTED,
  BACKUP365_REPORT_COMPANIES_NOTFOUND,
  BACKUP365_REPORT_DATES_LOADED,
  BACKUP365_REPORT_DATES_NOTFOUND,
  BACKUP365_REPORT_DATE_SELECTED,
  BACKUP365_REPORT_DATE_CLEARED,
  BACKUP365_REPORT_RECONS_LOADED,
  BACKUP365_REPORT_RECONS_NOTFOUND,
  BACKUP365_REPORT_PENDING_RECON_LOADED,
  BACKUP365_REPORT_PENDING_RECON_NOTFOUND,
  BACKUP365_REPORT_ADD_RECON_USERS_REQUEST,
  BACKUP365_REPORT_ADD_RECON_USERS_SUCCESS,
  BACKUP365_REPORT_ADD_RECON_USERS_FAILURE,
  BACKUP365_REPORT_REFRESH_RECON_LOADING,
  BACKUP365_REPORT_REFRESH_RECON_LOADED,
  BACKUP365_REPORT_REFRESH_RECON_FAILED,
  BACKUP365_EXCLUDED_DOMAINS_SAVING,
  BACKUP365_EXCLUDED_DOMAINS_SAVED,
  BACKUP365_EXCLUDED_DOMAINS_SAVE_FAILED,
} from './backup365ReportsTypes'

export const handleReportLoading = () => {
  return {
    type: BACKUP365_REPORT_LOADING,
  }
}

export const saveExcludedDomains = (companyId, domains) => {
  return async (dispatch) => {
    try {
      dispatch({ type: BACKUP365_EXCLUDED_DOMAINS_SAVING })

      const res = await api.post(`/Backup365Reports/SaveExcludedDomains`, {
        CompanyId: companyId,
        ExcludedDomains: domains,
      })

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`)
      }

      const success = await res.json()

      if (success === true) {
        dispatch({ type: BACKUP365_EXCLUDED_DOMAINS_SAVED })
        dispatch(addSaveToast('Excluded domains saved successfully.'))
      } else {
        throw new Error('Server returned success=false')
      }
    } catch (error) {
      dispatch({
        type: BACKUP365_EXCLUDED_DOMAINS_SAVE_FAILED,
        payload: error.message || 'Something went wrong',
      })
      dispatch(addErrorToast('Failed to save excluded domains. Please try again later.'))
    }
  }
}

export const handleAddReconUsers = (reconId, productId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BACKUP365_REPORT_ADD_RECON_USERS_REQUEST })

      const state = getState()

      const selectedCompany = state.backup365Reports.selectedCompany
      if (selectedCompany == null) throw new Error('No company selected')

      const product = state.backup365Reports.pendingCompanyRecon.reconciliationProducts.find((p) => p.id === productId)

      if (product == null) throw new Error('Product not found in pending reconciliation')

      const name = product.name.toLowerCase()

      let licenseType = name.includes('complete') ? 'Complete' : name.includes('mailbox') ? 'Mailbox' : 'Unknown'

      const users = state.backup365Reports.reportDetails.users
        .filter((u) => u.ositLicenseType === licenseType)
        .map((u) => u.userPrincipleName)

      const agreementName = state.backup365Reports.pendingCompanyRecon?.agreement?.name || ''

      const isManagedClient = agreementName.toLowerCase().includes('managed')

      const postObject = {
        IsEssentialsSelected: !isManagedClient,
        Data: users.map((username) => ({
          Username: username,
        })),
      }

      await api.post(`/reconciliation/${reconId}/Product/${productId}/Upload/${selectedCompany.value}`, postObject)

      dispatch({ type: BACKUP365_REPORT_ADD_RECON_USERS_SUCCESS })

      if (selectedCompany?.value) {
        dispatch(fetchPendingCompanyRecon(selectedCompany.value))
      }
      dispatch(addSaveToast('Users added to reconciliation successfully'))
    } catch (error) {
      dispatch(addErrorToast(error))

      dispatch({
        type: BACKUP365_REPORT_ADD_RECON_USERS_FAILURE,
        payload: error.message || 'Something went wrong',
      })
    }
  }
}

export const handleReportCompanyLabelsLoaded = (payload) => {
  return {
    type: BACKUP365_REPORT_COMPANIES_LOADED,
    payload: payload,
  }
}

export const handleReportDetailsLoaded = (payload) => {
  return {
    type: BACKUP365_REPORT_DETAILS_LOADED,
    payload: payload,
  }
}

export const handleReportDetailsNotFound = () => {
  return {
    type: BACKUP365_REPORT_DETAILS_NOTFOUND,
  }
}

export const handleReportCompanyLabelsNotFound = () => {
  return {
    type: BACKUP365_REPORT_COMPANIES_NOTFOUND,
  }
}
export const handleBackupReconsLoaded = (payload) => {
  return {
    type: BACKUP365_REPORT_RECONS_LOADED,
    payload: payload,
  }
}

export const handleBackupReconsNotFound = () => {
  return {
    type: BACKUP365_REPORT_RECONS_NOTFOUND,
  }
}

export const handleAutoRecon =
  (reportOnly = false) =>
  async (dispatch) => {
    try {
      const res = await api.post(`/Backup365Reports/AutoRecon?reportOnly=${reportOnly}`)

      if (res.ok) {
        dispatch(
          addSaveToast(
            reportOnly
              ? 'Auto reconciliation report job initiated successfully.'
              : 'Auto reconciliation job initiated successfully.'
          )
        )
      } else {
        throw new Error(`HTTP ${res.status}`)
      }
    } catch {
      if (reportOnly) {
        dispatch(addErrorToast('Failed to initiate auto reconciliation report. Please try again in 5 minutes.'))
      } else {
        dispatch(addErrorToast('Failed to initiate auto reconciliation. Please try again in 60 minutes.'))
      }
    }
  }

export const handleSyncCompany = (companyId) => async (dispatch) => {
  try {
    const res = await api.post(`/Backup365Reports/SyncCompany`, { CompanyId: companyId })
    if (res.ok) {
      dispatch(addSaveToast('Sync initiated successfully.'))
    }
  } catch (e) {
    dispatch(addErrorToast('Failed to initiate sync. Please try again later.'))
  }
}

export const fetchBackupRecons = () => async (dispatch) => {
  dispatch(handleReportLoading())

  try {
    const res = await api.get(`/Backup365Reports/GetBackupRecons`)
    const data = await res.json()

    dispatch(handleBackupReconsLoaded(data))
  } catch (e) {
    dispatch(handleBackupReconsNotFound())
  }
}

export const refreshBackupRecon = (companyId) => async (dispatch, getState) => {
  try {
    var i = getState().backup365Reports.backupRecons.findIndex((r) => r.companyId === companyId)

    dispatch({ type: BACKUP365_REPORT_REFRESH_RECON_LOADING, payload: i })

    const res = await api.get(`/Backup365Reports/GetBackupRecon/${companyId}`)
    const data = await res.json()

    dispatch({
      type: BACKUP365_REPORT_REFRESH_RECON_LOADED,
      payload: { index: i, recon: data },
    })

    dispatch(addSaveToast('Reconciliation refreshed successfully.'))
  } catch (e) {
    dispatch({ type: BACKUP365_REPORT_REFRESH_RECON_FAILED })
    dispatch(addErrorToast('Failed to refresh reconciliation. Please try again later.'))
  }
}

export const handePendingCompanyReconLoaded = (payload) => {
  return {
    type: BACKUP365_REPORT_PENDING_RECON_LOADED,
    payload: payload,
  }
}

export const handlePendingCompanyReconNotFound = () => {
  return {
    type: BACKUP365_REPORT_PENDING_RECON_NOTFOUND,
  }
}

export const fetchPendingCompanyRecon = (companyId) => async (dispatch, getState) => {
  dispatch(handleReportLoading())

  try {
    var date = getState().backup365Reports.selectedReportDate

    if (!date) {
      throw new Error('No report date selected')
    }

    var postObject = {
      CompanyId: companyId,
      ReportDate: date.value,
    }
    const res = await api.post(`/Backup365Reports/GetBackupRecon`, postObject)
    const data = await res.json()
    dispatch(handePendingCompanyReconLoaded(data))
  } catch (e) {
    dispatch(addErrorToast('Failed to load reconciliation. Please try again later.'))
    dispatch(handlePendingCompanyReconNotFound())
  }
}

export const fetchReportDetails = (company, reportDate) => async (dispatch) => {
  dispatch(handleReportLoading())
  try {
    var postObject = {
      CompanyId: company.value,
      ReportDate: reportDate,
    }
    const res = await api.post(`/Backup365Reports/GenerateCompanyReport`, postObject)

    const data = await res.json()

    dispatch(handleReportDetailsLoaded(data))
  } catch (e) {
    dispatch(handleReportDetailsNotFound())
  }
}

export const reportDateChanged = (datePayload) => async (dispatch, getState) => {
  await dispatch(handleReportDateSelected(datePayload))

  const state = getState()
  const selectedCompany = state.backup365Reports.selectedCompany

  if (selectedCompany && datePayload?.value) {
    await dispatch(fetchReportDetails(selectedCompany, datePayload.value))
  } else {
    dispatch(fetchReportDetails(null))
  }

  dispatch(fetchPendingCompanyRecon(selectedCompany.value))
}

export const handleReportDateSelected = (payload) => {
  return {
    type: BACKUP365_REPORT_DATE_SELECTED,
    payload: payload,
  }
}

const handleReportDateCleared = () => {
  return {
    type: BACKUP365_REPORT_DATE_CLEARED,
  }
}

const handleAvailableReportDatesLoaded = (payload) => {
  return {
    type: BACKUP365_REPORT_DATES_LOADED,
    payload: payload,
  }
}
const handleAvailableReportDatesNotFound = () => {
  return {
    type: BACKUP365_REPORT_DATES_NOTFOUND,
  }
}

export const fetchAvailableReportDates = (payload) => async (dispatch) => {
  dispatch(handleReportLoading())

  try {
    var postObject = {
      CompanyId: payload.value,
    }
    const res = await api.post(`/Backup365Reports/GetAvailableReportDates`, postObject)
    const data = await res.json()

    dispatch(handleAvailableReportDatesLoaded(data))
    return data
  } catch (e) {
    dispatch(handleAvailableReportDatesNotFound())
    return []
  }
}

export const reportingCompanySelected = (payload) => async (dispatch) => {
  dispatch(handleReportLoading())

  try {
    dispatch(handleSelectedCompany(payload))
    const dates = await dispatch(fetchAvailableReportDates(payload))
    if (dates && dates.length > 0) {
      const datePayload = {
        value: dates[0],
        label: new Date(dates[0]).toLocaleDateString('en-AU', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
      }
      await dispatch(handleReportDateSelected(datePayload))
      await dispatch(fetchReportDetails(payload, dates?.[0] ?? null))
      await dispatch(fetchPendingCompanyRecon(payload.value))
    } else {
      dispatch(fetchReportDetails(null))
    }
  } catch (e) {
    dispatch(handleReportDetailsNotFound())
  }
}

export const handleSelectedCompany = (payload) => {
  return {
    type: BACKUP365_REPORT_COMPANY_SELECTED,
    payload: payload,
  }
}

export const fetchReportCompanyList = () => async (dispatch) => {
  dispatch(handleReportLoading())

  try {
    const res = await api.get(`/Backup365Reports/GetCompanyLabels`)

    const data = await res.json()

    dispatch(handleReportCompanyLabelsLoaded(data))
  } catch (e) {
    dispatch(handleReportCompanyLabelsNotFound())
  }
}
